import React, { useState } from 'react';
import { mockBlogPosts } from '../data/mockBlog';
import BlogCard from '../components/blog/BlogCard';

export default function BlogIndexPage() {
  const [activeFilter, setActiveFilter] = useState('all'); // all, article, leader

  const filteredPosts = mockBlogPosts.filter(post => {
    if (activeFilter === 'all') return true;
    return post.type === activeFilter;
  });

  return (
    <div className="pb-24">
      {/* Hero Header */}
      <div className="bg-[var(--bg-surface)] border-b border-[var(--border-subtle)] py-16 md:py-24 px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl md:text-6xl font-black text-[var(--text-main)] tracking-tighter uppercase italic leading-[0.9] mb-6">
            La Voz del <br />
            <span className="gfi-gradient-text">Movimiento</span>
          </h1>
          <p className="text-[var(--text-secondary)] font-medium text-lg leading-relaxed max-w-xl mx-auto">
            Educación financiera, noticias y las historias de los líderes que están transformando nuestra comunidad.
          </p>
        </div>
      </div>

      {/* Filters */}
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="flex flex-wrap items-center justify-center gap-3 mb-12">
          {[
            { id: 'all', label: 'Todo el Contenido' },
            { id: 'article', label: 'Educación & Noticias' },
            { id: 'leader', label: 'Historias de Líderes' }
          ].map(filter => (
            <button
              key={filter.id}
              onClick={() => setActiveFilter(filter.id)}
              className={`px-6 py-3 rounded-full text-[10px] font-black uppercase tracking-[0.2em] transition-all border ${
                activeFilter === filter.id
                  ? 'bg-[var(--text-main)] text-[var(--bg-base)] border-[var(--text-main)] shadow-lg'
                  : 'bg-[var(--bg-surface)] text-[var(--text-secondary)] border-[var(--border-subtle)] hover:border-[var(--text-main)]/30'
              }`}
            >
              {filter.label}
            </button>
          ))}
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredPosts.map(post => (
            <BlogCard key={post.id} post={post} />
          ))}
        </div>
      </div>
    </div>
  );
}